import showToast from '@Common/toast/showToast';
import { useGeneratorContext } from '@Context/GeneratorContext';
import { useQueueContext } from '@Context/QueueContext';
import { FeatDescrip } from '@Models/types';
import { Backspace, Trash } from '@phosphor-icons/react';

const Requirements = () => {
  const {
    selectedRequirements,
    setSelectedRequirements,
    generateTestCases,
    selectedPrompt,
  } = useGeneratorContext();
  const { addToQueue } = useQueueContext();

  const removeRequirement = (item: FeatDescrip) => {
    const filtered = selectedRequirements.filter(
      (i) => i.reference_num !== item.reference_num
    );
    setSelectedRequirements(filtered);
  };

  const handleGenerate = async () => {
    showToast.info('Generating Test Cases', 'generate-tc');
    setSelectedRequirements([]);
    const queue = await generateTestCases(selectedRequirements);
    addToQueue(queue.queueId, false);
  };

  const clearRequirements = () => {
    setSelectedRequirements([]);
  };

  return (
    <>
      <div className="flex flex-row items-center justify-between pb-2 text-xs sm:text-sm">
        <div>Requirements</div>
        <Trash
          data-testid="test-requirements-clear-btn"
          onClick={() => clearRequirements()}
          size={20}
          className="cursor-pointer hover:text-brandRed-500"
        />
      </div>

      {/* Add prompt override indicator */}
      {selectedPrompt && (
        <div className="mb-2 rounded-md border border-blue-200 bg-blue-50 p-2 text-xs">
          <div className="font-medium text-blue-700">
            Prompt Override Active
          </div>
          <div className="text-blue-600">
            Using: Version {selectedPrompt.version}
            {selectedPrompt.nickname && ` - ${selectedPrompt.nickname}`}
          </div>
        </div>
      )}

      {selectedRequirements.length === 0 && (
        <div className="px-2 text-xs italic">No Requirements Added</div>
      )}

      <div className="flex flex-col gap-y-2">
        <div className="flex flex-col gap-y-2">
          {selectedRequirements.length > 0 &&
            selectedRequirements.map((req, index) => (
              <div
                key={index}
                className="flex flex-row items-center justify-between rounded-md bg-gray-200 px-4 py-2"
              >
                <span className="flex flex-row items-center gap-x-2 text-xs sm:text-sm">
                  <div>{req.reference_num}</div>
                </span>

                <Backspace
                  role="button"
                  size={20}
                  onClick={() => removeRequirement(req)}
                  weight="regular"
                  className="cursor-pointer hover:text-brandRed-500"
                />
              </div>
            ))}
        </div>

        {selectedRequirements.length > 0 && (
          <button
            onClick={handleGenerate}
            className="rounded-lg bg-primary-700 font-bold text-white hover:bg-primary-500 disabled:bg-white disabled:text-brandWarning-500"
          >
            <div className="px-4 py-2 text-xs">Generate Test Cases</div>
          </button>
        )}
      </div>
    </>
  );
};

export default Requirements;
